// 빈 문자열("")도 유효값(= same-origin 상대경로)으로 취급한다.
// `|| 기본값` 을 쓰면 빈 문자열이 falsy 라 localhost 로 잘못 떨어진다.
const API_BASE = process.env.REACT_APP_API_BASE === undefined
  ? 'http://localhost:3003'
  : process.env.REACT_APP_API_BASE;
const HANSEM_API_BASE = process.env.REACT_APP_HANSEM_API_BASE || 'https://api.winteckorea.kr';

const ensureLeadingSlash = (path = '') => {
  if (!path) return '';
  return path.startsWith('/') ? path : `/${path}`;
};

export const buildApiUrl = (path = '') => `${API_BASE}${ensureLeadingSlash(path)}`;
export const buildHansemApiUrl = (path = '') => `${HANSEM_API_BASE}${ensureLeadingSlash(path)}`;

export { API_BASE, HANSEM_API_BASE };
